module.exports = __webpack_public_path__ + "static/travelworld_icons-fc9d4cf1e17ad859103b17843e46fba5.svg";